import { ElementType, IElement } from '../../../models/Element';

// Only these keys are read by the API blade template
// (resources/views/livewire/elements/form/form-cancellation.blade.php);
// all other form fields and labels are hardcoded server-side.
export type FormCancellation = IElement & {
  title: string;

  heading_primary: string;

  success_message?: string;
};

export const defaultFormCancellation: FormCancellation = {
  id: 0,
  name: ElementType.FORM_CANCELLATION,

  title: 'Opzeggen',

  heading_primary: 'Jouw gegevens',
};
